module.exports = __webpack_public_path__ + "img/space-and-stars.a7fe22be.png";